import { useSelector } from "react-redux";

const useCurrentEnvironment = () => {
  return useSelector((state) => {
    // @ts-ignore
    return state.environments.currentEnvironment;
  });
};

export default useCurrentEnvironment;
